class SimpleJqueryAccordion {
    init(accordionClass) {
        $('.' + accordionClass + ' .toggle').click(function(e) {
            e.preventDefault();

            let $this = $(this);

            const isOpen = $this.hasClass('open');

            $this.parent().parent().find('li .toggle').removeClass('open');

            if(!isOpen){
                $this.addClass('open')
            }

            if ($this.next().hasClass('show')) {
                $this.next().removeClass('show');
                $this.next().slideUp(350);
            } else {
                $this.parent().parent().find('li .inner').removeClass('show');
                $this.parent().parent().find('li .inner').slideUp(350);
                $this.next().toggleClass('show');
                $this.next().slideToggle(350);
            }
        });
    }
}

export default SimpleJqueryAccordion;